<template>
    <ion-toolbar color="danger">
      <div class="ion-text-center">
        <ion-text>⚠セキュリティエラー</ion-text>
      </div>
    </ion-toolbar>

    <ion-content class="ion-padding">
      <ion-header>
        kutsu.comアプリの会員利用規約に基づき、ご登録のアカウントは利用停止措置が取られています。
        <br />
        kutsu.comアプリをご利用いただくにあたって、本アプリの会員規約に違反する行為のあった場合には、当社の判断で、本アプリの利用停止措置を取らせていただく場合がございます。
        <br />
        お心あたりがない場合は、下記問い合わせよりお問い合わせください。
        <br /><br />
        電話：0120-139-719<br />
        ※平日11:00～12:00 13:00～17:00<br />
        ※土曜・日曜・祝日、年末年始を除く<br /><br />
        メール：point@chiyodagrp.co.jp<br /><br />
        株式会社チヨダお客様相談室<br />
        電話：0120-952-106<br />
        ※平日は10:00～13:00、14:00～17:00<br />
        ※土曜・日曜・祝日、年末年始を除く<br />
        ※下記お問い合わせフォームからもお問い合わせいただけます。<br />
        https://www.chiyodagrp.co.jp/smp/mail/
      </ion-header>
  </ion-content>
</template>

<script lang="ts" setup>
  import { IonContent, IonToolbar} from '@ionic/vue'
  import { useRouter } from 'vue-router'
  import { onBeforeMount } from 'vue';
  const router = useRouter()

  onBeforeMount(async () => {
    await router.replace({name: 'FirstOfConfirmationWhenStartup'})
  })
</script>

<style>
  ion-modal.security-error-modal {
    --height: 65%;
    --max-height: 85%;
    --width: 80%;
    --border-radius: 16px;
    --backdrop-opacity: 0.75;
  }
</style>
